export default "__VITE_ASSET__C79WPE7j__"